import { render } from "./contact-agent-field.vue?vue&type=template&id=02968808&scoped=true&ts=true"
import script from "./contact-agent-field.vue?vue&type=script&lang=ts"
export * from "./contact-agent-field.vue?vue&type=script&lang=ts"

import "./contact-agent-field.vue?vue&type=style&index=0&id=02968808&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02968808"]])

export default __exports__